module.exports = __webpack_public_path__ + "img/banner_2000.d9266549.webp";